import { useId } from 'react';

import { FederatedModule } from '@zenbusiness/application-commons-federation';
import { LoadingZone } from '@zenbusiness/application-commons-loading';

import { FEDERATED } from '#client/build-env';

function DocumentsWidgetV1() {
  const widgetId = useId();
  return (
    <>
      <LoadingZone.Prepare loadId={widgetId} />
      <FederatedModule
        exportName="DocumentsWidgetV1"
        loadId="documents-widget"
        silent
        widgetId={widgetId}
        {...FEDERATED.DocumentsUi}
      />
    </>
  );
}

export default DocumentsWidgetV1;
